export default __webpack_public_path__ + "static/media/JuanCarlosPineda_ponentes.2261dd79.png";